module.exports = __webpack_public_path__ + "static/media/sami.ylitalo.bc939fbc.jpg";